import React from 'react'

const TagBar = () => {
    return (
        <main className="main">
            <div className="tag-bar-area">
                <div className="container1">
                    <span className="text">True love doesn’t mean being inseparable.<br /> It means being separate and nothing changes.</span>
                </div>
            </div>
        </main>
    )
}

export default TagBar
